import React, { useState, useEffect } from 'react';
import { Button, Space, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import partnerUsersApi from '../api/partnerUsersApi';
import PartnerUserTable from '../components/users/PartnerUserTable';
import PartnerUserForm from '../components/users/PartnerUserForm';

const PartnerUsersTab = ({ partnerId }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [formLoading, setFormLoading] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, [partnerId]);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const data = await partnerUsersApi.getByPartner(partnerId);
      setUsers(data.data || []);
    } catch (error) {
      message.error(error.response?.data?.message || 'Failed to fetch users');
    } finally {
      setLoading(false);
    }
  };

  const handleAddUser = () => {
    setIsFormVisible(true);
  };

  const handleFormClose = () => {
    setIsFormVisible(false);
  };

  const handleFormSubmit = async (formData) => {
    setFormLoading(true);
    try {
      await partnerUsersApi.create(partnerId, formData);
      message.success('User created successfully');
      handleFormClose();
      fetchUsers();
    } catch (error) {
      message.error(error.response?.data?.message || 'Failed to create user');
    } finally {
      setFormLoading(false);
    }
  };

  return (
    <div>
      <Space style={{ marginBottom: 16 }}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleAddUser}
        >
          Add New User
        </Button>
      </Space>

      <PartnerUserTable
        partnerId={partnerId}
        users={users}
        loading={loading}
        onRefresh={fetchUsers}
      />

      <PartnerUserForm
        visible={isFormVisible}
        user={null}
        onClose={handleFormClose}
        onSubmit={handleFormSubmit}
      />
    </div>
  );
};

export default PartnerUsersTab;
